import { useQuery } from "@tanstack/react-query";
import { applyTakeoverSuppression } from "@nodus/announcements";
import { useAnnouncements } from "@/hooks/use-announcements";
import { useAnnouncementDismissal } from "@/lib/announcements-dismissal";
import { announcementsApi, emergencyApi } from "@/lib/api/client";
import { screenTaken } from "@/lib/guides";

/**
 * Whether a fullscreen announcement, a takeover or an emergency owns the
 * screen right now — the guide popup and the guide modal step aside while one
 * does (#436). Reads the queries the announcements host and the shell fill
 * (observers with `enabled: false`: no extra fetch).
 */
export function useScreenTaken() {
  const announcements = useAnnouncements();
  const { isDismissed } = useAnnouncementDismissal();
  const announcementsState = useQuery({
    queryKey: ["announcements"],
    queryFn: () => announcementsApi.list().then((r) => r.data),
    enabled: false,
  });
  const emergency = useQuery({
    queryKey: ["emergency-state"],
    queryFn: () => emergencyApi.get().then((r) => r.data),
    enabled: false,
  });
  const visibleAnnouncements = applyTakeoverSuppression(announcements).filter((a) => !isDismissed(a));
  const emergencyActive = !!emergency.data?.active;
  return {
    visibleAnnouncements,
    emergencyActive,
    announcementsLoaded: announcementsState.isFetched,
    emergencyLoaded: emergency.isFetched,
    covered: screenTaken(visibleAnnouncements, emergencyActive),
  };
}
